define(function (require) {
    require("@modules/tools/ko.async");
    require("@modules/tools/ko.extensions");

    var ko = require("knockout");
    var $ = require("jquery");
    var urlParameters = require("@modules/tools/urlParameters");
    var querystring = require("querystring");
    var utility = require("@modules/tools/helpfulToolUtility");
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    require("@modules/content/helpfulBlockOverlay/helpfulBlockOverlay");
    require("@modules/portal/favorites");
    require("@modules/overlay");

    // FormularyDetailViewModel ctor
    return function (gtmDataLayerPushFunction, selectYearText, selectStateText, selectCountyText, selectPlanText, selectSubsidyText, selectedState) {
        var self = this;
        var initialLoad = true;

        var currentSubscription = window.scan.accountMetadata;
        var defaultSelectYearText = selectYearText;
        var defaultSelectStateText = selectStateText;
        var defaultSelectCountyText = selectCountyText;
        var defaultSelectPlanText = selectPlanText;
        var defaultSelectSubsidyText = selectSubsidyText;
        var isStateExpansionFeatureEnabled = window.scan.formularyDetail && window.scan.formularyDetail.isStateExpansionFeatureEnabled === true;

        // api service
        self.formularyService = require("@modules/tools/formulary-search/formularyDetailService");

        self.initialLoad = ko.pureComputed(function () {
            return initialLoad;
        });
        self.fatalError = ko.observable(false);
        self.loadingResults = ko.observable(false);
        self.year = ko.observable();
        self.yearOptions = ko.observableArray([]);
        self.state = ko.observable();
        self.stateOptions = ko.observableArray(window.scan.formularyStates);
        self.county = ko.observable();
        self.countyOptions = ko.observableArray([]);
        self.plan = ko.observable();
        self.planOptions = ko.observableArray([]);
        self.subsidy = ko.observable();
        self.subsidyOptions = ko.observableArray([]);
        self.showSubsidyLevel = ko.observable();
        self.eocUrl = ko.observable();

        self.formularyId = ko.observable();
        self.formularyyear = ko.observable();

        // search results
        self.copays = ko.observableArray([]);

        // displayed copay values
        self.mail30 = ko.computed(function () {
            return self.copays() && self.copays()["day30"] && self.copays()["day30"]["mail"] ? self.copays()["day30"]["mail"] : "";
        });
        self.mail60 = ko.computed(function () {
            return self.copays() && self.copays()["day60"] && self.copays()["day60"]["mail"] ? self.copays()["day60"]["mail"] : "";
        });
        self.mail90 = ko.computed(function () {
            return self.copays() && self.copays()["day90"] && self.copays()["day90"]["mail"] ? self.copays()["day90"]["mail"] : "";
        });
        self.preferred30 = ko.computed(function () {
            return self.copays() && self.copays()["day30"] && self.copays()["day30"]["preferred"] ? self.copays()["day30"]["preferred"] : "";
        });
        self.preferred60 = ko.computed(function () {
            return self.copays() && self.copays()["day60"] && self.copays()["day60"]["preferred"] ? self.copays()["day60"]["preferred"] : "";
        });
        self.preferred90 = ko.computed(function () {
            return self.copays() && self.copays()["day90"] && self.copays()["day90"]["preferred"] ? self.copays()["day90"]["preferred"] : "";
        });
        self.standard30 = ko.computed(function () {
            return self.copays() && self.copays()["day30"] && self.copays()["day30"]["standard"] ? self.copays()["day30"]["standard"] : "";
        });
        self.standard60 = ko.computed(function () {
            return self.copays() && self.copays()["day60"] && self.copays()["day60"]["standard"] ? self.copays()["day60"]["standard"] : "";
        });
        self.standard90 = ko.computed(function () {
            return self.copays() && self.copays()["day90"] && self.copays()["day90"]["standard"] ? self.copays()["day90"]["standard"] : "";
        });

        self.incompleteResults = ko.pureComputed(function () {
            return !self.preferred30().length || !self.preferred60().length || !self.preferred90().length || !self.standard30().length || !self.standard60().length || !self.standard90().length;
        });

        self.isCurrentSubscriber = ko.pureComputed(function () {
            return !!(currentSubscription && currentSubscription.IsAuthenticated);
        });

        self.isStateExpansionFeatureEnabled = ko.computed(function () {
            return isStateExpansionFeatureEnabled;
        });

        var urlParams = urlParameters.read();
        var path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));
        self.formularyId(urlParams.formularyId || "");
        self.formularyyear(urlParams.formularyyear || "");

        if (!self.formularyId().length || !self.formularyyear().length) {
            self.fatalError(true);
        }

        utility.initializeFilters(self, urlParams, {});

        self.filters = ko.computed({
            read: function () {
                return {
                    year: self.year(),
                    state: self.state(),
                    county: self.county(),
                    plan: self.plan(),
                    subsidy: self.subsidy()
                };
            },
            deferEvaluation: true
        });

        self.filters.subscribe(
            function () {
                self.showSubsidyLevel(false);
            },
            null,
            "beforeChange"
        );

        self.year.subscribe(function () {
            if (isStateExpansionFeatureEnabled) {
                self.state("");
                self.county("");
            } else {
                self.county("");
            }
        });

        self.state.subscribe(function () {
            self.county("");
            BindCounty();
        });

        self.county.subscribe(function () {
            self.plan("");
            BindPlans();
        });

        self.plan.subscribe(function () {
            self.subsidy("");
            self.copays([]);
        });

        self.urlParameters = ko
            .computed(function () {
                return {
                    formularyId: self.formularyId(),
                    formularyyear: self.formularyyear(),
                    path: path
                };
            })
            .extend({ deferred: true });

        self.urlParameters.subscribe(function (params) {
            urlParameters.write(params, {});
        });
        // this combines the currently selected values into a parameters object
        // for passing to our facets/results services.
        self.searchParameters = ko
            .computed(function () {
                var filters = self.filters();

                //Example search url:
                // https://scanhealthplan.resultsbuilder.com/api/formularycopay/results?
                //     formularyId=66678&
                //     formularyyear=2018&
                //     plan=SCAN%20Classic%20(HMO)&
                //     year=2017&SubsidyLevel=Standard&
                //     state=CA&
                //     county=Ventura

                return {
                    formularyId: self.formularyId(),
                    formularyyear: self.formularyyear(),
                    subsidyLevel: self.subsidy(),
                    year: filters.year,
                    state: filters.state,
                    county: filters.county,
                    plan: filters.plan,
                    subsidy: filters.subsidy
                };
            })
            .extend({ deferred: true });

        self.searchParameters.subscribe(function () {
            if (!self.year()) {
                return;
            }
            executeSearch(self.searchParameters());
        });

        self.pdfUrl = ko.computed(function () {
            return "/controller/FormularyDetailPdf/Download?" + querystring.stringify(self.searchParameters());
        });

        var lastSearchRequestId = 1;
        function executeSearch(parameters) {
            gtmDataLayerPushFunction(parameters, {});

            self.fatalError(false);

            self.loadingResults(true);

            var id = ++lastSearchRequestId;

            self.formularyService
                .getOptions(parameters)
                .done(function (results) {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }
                    self.yearOptions(
                        [
                            {
                                count: 0,
                                name: defaultSelectYearText,
                                text: "",
                                value: ""
                            }
                        ].concat(results.Facets.Year)
                    );
                    //self.stateOptions(
                    //    [
                    //        {
                    //            count: 0,
                    //            name: defaultSelectStateText,
                    //            text: "",
                    //            value: ""
                    //        }
                    //    ].concat(results.Facets.State)
                    //);
                    //self.countyOptions(
                    //    [
                    //        {
                    //            count: 0,
                    //            name: "",
                    //            text: defaultSelectCountyText,
                    //            value: ""
                    //        }
                    //    ].concat(results.Facets.County)
                    //);
                    //self.planOptions(
                    //    [
                    //        {
                    //            count: 0,
                    //            name: defaultSelectPlanText,
                    //            text: "",
                    //            value: ""
                    //        }
                    //    ].concat(results.Facets.Plan)
                    //);
                    self.subsidyOptions(
                        [
                            {
                                count: 0,
                                name: defaultSelectSubsidyText,
                                text: "",
                                value: ""
                            }
                        ].concat(results.Facets.SubsidyLevel)
                    );

                    self.loadingResults(false);

                    if (initialLoad) {
                        if (
                            currentSubscription &&
                            currentSubscription.IsAuthenticated &&
                            (!urlParams.year || self.year() !== urlParams.year) &&
                            (!urlParams.state || self.state() !== urlParams.state) &&
                            (!urlParams.county || self.county() !== urlParams.county) &&
                            (!urlParams.plan || self.plan() !== urlParams.plan)
                        ) {
                            console.log("setting current user subscriptions");
                            self.year(urlParams.year || currentSubscription.PlanYear);
                            self.state(urlParams.state || currentSubscription.PlanState);
                            self.county(urlParams.county || currentSubscription.PlanCounty);
                            self.plan(urlParams.plan || currentSubscription.PlanName);

                            if (self.state() != undefined && self.state() != null && self.state() != "") {
                                BindCounty();
                            }

                            if (self.county() != undefined && self.county() != null && self.county() != "") {
                                BindPlans();
                            }

                            // remove blank options
                            self.yearOptions(
                                self.yearOptions().filter(function (obj) {
                                    return obj.value !== "";
                                })
                            );
                            self.stateOptions(
                                self.stateOptions().filter(function (obj) {
                                    return obj.value !== "";
                                })
                            );
                            self.countyOptions(
                                self.countyOptions().filter(function (obj) {
                                    return obj.value !== "";
                                })
                            );
                            self.planOptions(
                                self.planOptions().filter(function (obj) {
                                    return obj.value !== "";
                                })
                            );
                            self.subsidyOptions(
                                self.subsidyOptions().filter(function (obj) {
                                    return obj.value !== "";
                                })
                            );
                        }
                    }
                    if (results.EocUrl) {
                        $(".copay_disclaimer_eoc").attr("href", results.EocUrl);
                        $(".copay_disclaimer_eoc").removeAttr("style");
                    } else {
                        $(".copay_disclaimer_eoc").removeAttr("href");
                        $(".copay_disclaimer_eoc").attr("style", "text-decoration: none; color: #000000;");
                    }
                    self.showSubsidyLevel(results.ShowSubsidyLevel);

                    if (currentSubscription.IsEmployerGroupPlan) {
                        $(".copayContainer").hide();
                    }

                    self.copays(results.Copays);

                    initialLoad = false;

                    if (selectedState !== "" && $("#coPayState").val() === "" && $("#coPayState option[value='" + selectedState + "']").length > 0) {
                        $("#coPayState").val(selectedState).trigger("change");
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }
                    self.fatalError(true);
                    self.loadingResults(false);
                });
        }

        function BindCounty() {
            const parameters = {
                state: self.state()
            };
            self.formularyService.getCounties(parameters, false).done(function (results) {
                try {
                    if (results && results.length > 0) {
                        self.countyOptions(
                            [
                                {
                                    count: 0,
                                    name: "",
                                    Text: defaultSelectCountyText,
                                    Value: ""
                                }
                            ].concat(results)
                        );
                    }
                } catch (e) {
                    log(e.message);
                }
            });
        }

        function BindPlans() {
            const parameters = {
                state: self.state(),
                county: self.county(),
                year: self.year()
            };

            self.formularyService.getPlans(parameters, false).done(function (results) {
                try {
                    if (results && results.length > 0) {
                        self.planOptions(
                            [
                                {
                                    count: 0,
                                    name: "",
                                    Text: defaultSelectPlanText,
                                    Value: ""
                                }
                            ].concat(results)
                        );
                    }
                    else {
                        self.planOptions(
                            [
                                {
                                    count: 0,
                                    name: "",
                                    Text: defaultSelectPlanText,
                                    Value: ""
                                }
                            ]
                        );
                    }
                } catch (e) {
                    log(e.message);
                }
            });
        }
        self.areAllRequiredFieldsPopulated = ko.computed(function () {
            var filterArray = self.filters();
            for (var i in filterArray) {
                if (filterArray.hasOwnProperty(i)) {
                    if ((i === "subsidy" && self.showSubsidyLevel()) || i !== "subsidy") {
                        if (!filterArray[i]) {
                            return false;
                        }
                    }
                }
            }
            return true;
        });

        self.yearOptionsFiltered = ko.computed(function () {
            return self.yearOptions().filter(function (opt) {
                return opt.value !== "";
            });
        });

        self.stateOptionsFiltered = ko.computed(function () {
            return self.stateOptions().filter(function (opt) {
                return opt.value !== "";
            });
        });

        self.yearOptions.subscribe(function () {
            // if only one option available, select it; markup binding takes care of visibility
            if (self.yearOptionsFiltered().length === 1) {
                // makes sure the control is fully rendered
                setTimeout(function () {
                    self.year(self.yearOptionsFiltered()[0].value);
                }, 250);
            }
        });

        self.stateDropdownEnabled = ko.computed(function () {
            var filters = self.filters();
            return self.yearOptionsFiltered().length === 1 || filters.year !== "";
        });

        self.countyDropdownEnabled = ko.computed(function () {
            if (isStateExpansionFeatureEnabled) {
                var filters = self.filters();
                return (self.yearOptionsFiltered().length === 1 || filters.year !== "") && (self.stateOptionsFiltered().length === 1 || filters.state !== "");
            }
            var filters = self.filters();
            return self.yearOptionsFiltered().length === 1 || filters.year !== "";
        });

        self.planDropdownEnabled = ko.computed(function () {
            var filters = self.filters();
            return filters.county !== "";
        });

        executeSearch(self.searchParameters());
        window.scan.formularyDetail = self;
    };
});
